import ChangePwd from "./ChangePwd";

export default ChangePwd;